import React, { useCallback } from "react";
import { useController, useWatch, Controller } from "react-hook-form";

import TierPrice, {
  convertTierPriceToString,
  parseTierPriceStringToJSON,
  validateTierPrice,
} from "./TierPrice";
import { isArray } from "../../helpers/methods";
import { Paper } from "@mui/material";

const TieredPricesInput = (props) => {
  const { source, searchFieldName, label } = props;
  const tieredPricesController = useController({ name: source });
  // const values = useWatch({ name: source, defaultValue: "" });
  const validateTieredPrices = useCallback((v) => {
    const isValid = validateTierPrice(v);
    if (v === "") {
      //empty string means no tier prices
      return undefined;
    } else if (isValid) {
      const prices = parseTierPriceStringToJSON(v);
      const qtyZeroes = prices.filter(({ minQuantity }) => minQuantity <= 0);
      if (qtyZeroes.length === 0) {
        return undefined;
      } else {
        return "Quantity must be larger than 0";
      }
    }
    return "Please correct tiered price setting";
  }, []);
  // const onRemoveTag = React.useCallback(
  //   (targetTag) => {
  //     const newTags = values.filter((tag) => tag.id !== targetTag.id);
  //     searchFieldNameInput.field.onChange(newTags);
  //   },
  //   [searchFieldNameInput.field, values]
  // );

  return (
    <>
      <span>
        <Controller
          name={source}
          control={tieredPricesController.control}
          rules={{ validate: validateTieredPrices }}
          render={({
            field: { onChange, onBlur, value },
            fieldState: { error },
          }) => (
            <Paper variant="outlined" sx={{ padding: "10px" }}>
              <span>{label}</span>
              <br />
              {error && <span style={{ color: "red" }}>{error.message}</span>}
              <TierPrice
                onChange={(rows) => {
                  if (isArray(rows)) {
                    const tieredPricesStr = convertTierPriceToString(rows);
                    tieredPricesController.field.onChange(tieredPricesStr);
                  } else {
                    onChange("");
                  }
                }}
                value={value}
                // {...props}
              />
            </Paper>
          )}
        />
      </span>
    </>
  );
};

export default TieredPricesInput;
